module.exports = __webpack_public_path__ + "static/img/banner02.98e5c437.png";